import { client, handleClientMethod } from "../client";
import type { PipelineMetrics, MetricsApiResponse } from "@onsemble/shared/types/internal";

export async function getMetrics(): Promise<PipelineMetrics> {
  const response = await handleClientMethod<MetricsApiResponse>(
    client.GET("/api/internal/products/metrics", {})
  );
  return response.data;
}
